var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    { ref: "tokenContainer", staticClass: "m-b-8 rtb-popover-container" },
    [
      _c(
        "button",
        {
          ref: "tokenButton",
          staticClass: "btn btn-secondary btn-sm",
          attrs: {
            id: "tokenButton",
            "data-cy": "token-button",
            type: "button"
          },
          on: { click: _vm.toggleMacrosPopover }
        },
        [_vm._v("\n    Token\n  ")]
      ),
      _vm._v(" "),
      _c(
        "popover",
        {
          attrs: {
            "custom-class": "breakdown-legend__popover",
            placement: "bottom",
            trigger: "manual",
            target: "#tokenButton"
          },
          on: {
            show: function($event) {
              _vm.tagsPopoverVisible = true
            },
            hide: function($event) {
              _vm.tagsPopoverVisible = false
            }
          },
          model: {
            value: _vm.showMacrosPopover,
            callback: function($$v) {
              _vm.showMacrosPopover = $$v
            },
            expression: "showMacrosPopover"
          }
        },
        [
          _c(
            "template",
            { slot: "popover" },
            [
              _c("MacroSelectionPopover", {
                attrs: {
                  "focus-dropdown": _vm.tagsPopoverVisible,
                  "trigger-element": _vm.$refs.tokenButton,
                  macros: _vm.macros
                },
                on: {
                  blur: function($event) {
                    _vm.showMacrosPopover = false
                  },
                  "selected-tag": _vm.onSelectedTag
                }
              })
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }